import { initReactI18next } from 'react-i18next'

import i18n from 'i18next'

import type { LandingLocale } from '@/navigation/localeConstants'
import { DEFAULT_LOCALE } from '@/navigation/localeConstants'

import enTranslation from '../public/locales/en/translation.json'
import esTranslation from '../public/locales/es/translation.json'
import { isTestEnvironment } from './environment.ts'

let initPromise: Promise<typeof i18n> | null = null

export function initI18n(lng: LandingLocale = DEFAULT_LOCALE): Promise<typeof i18n> {
    if (i18n.isInitialized) {
        if (i18n.language !== lng) {
            return i18n.changeLanguage(lng).then(() => i18n)
        }
        return Promise.resolve(i18n)
    }

    if (!initPromise) {
        initPromise = i18n
            .use(initReactI18next)
            .init({
                lng,
                fallbackLng: DEFAULT_LOCALE,
                supportedLngs: ['es', 'en'],
                nonExplicitSupportedLngs: true,
                load: 'languageOnly',
                debug: false,
                saveMissing: isTestEnvironment,
                saveMissingTo: 'all',
                resources: {
                    es: { translation: esTranslation },
                    en: { translation: enTranslation },
                },
                interpolation: {
                    escapeValue: false,
                },
                initImmediate: true,
            })
            .then(() => i18n)
    }

    return initPromise.then(async instance => {
        if (instance.language !== lng) {
            await instance.changeLanguage(lng)
        }
        return instance
    })
}

export default i18n
